// extracted by mini-css-extract-plugin
export default {"wrapper":"DetailModal_wrapper__9TWC3"};